import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFacebook, 
  faTwitter, 
  faInstagram, 
  faLinkedin, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = ({ setView }) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/images/logo.png" alt="cabptoid logo" className="logo-img" />
            <span className="logo-text">cabptoid</span>
          </div>
          <p>
            Empowering the world with intelligent solutions.
            Building the future, one node at a time.
          </p>
          <div className="footer-socials">
            <a href="https://www.facebook.com/profile.php?id=61587480283303" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://x.com/cabptoid91649" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://www.instagram.com/cabptoid_solutions/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.linkedin.com/company/cabptoid-solutions" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="https://www.youtube.com/channel/UC7jqBIA3cJMcuOq2JgSyksQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>

        {/* Company Links */}
        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about" onClick={(e) => { if(setView) { e.preventDefault(); setView('about'); } else window.scrollTo(0,0); }}>About Us</a></li>
            <li><a href="#careers">Careers</a></li>
            <li><a href="#insights" onClick={(e) => { if(setView) { e.preventDefault(); setView('insights'); } else window.scrollTo(0,0); }}>Blog</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Services Links */}
        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li><a href="#services" onClick={(e) => { if (setView) { e.preventDefault(); setView('service-detail', 'Performance Marketing'); } }}>Performance Marketing</a></li>
            <li><a href="#services" onClick={(e) => { if (setView) { e.preventDefault(); setView('service-detail', 'Influencer Marketing'); } }}>Influencer Marketing</a></li>
            <li><a href="#services" onClick={(e) => { if (setView) { e.preventDefault(); setView('service-detail', 'Celebrity & Influencer Marketing'); } }}>Celebrity Marketing</a></li>
            <li><a href="#services" onClick={(e) => { if (setView) { e.preventDefault(); setView('service-detail', 'Social Media Management'); } }}>Social Media Mgmt</a></li>
            <li><a href="#services" onClick={(e) => { if (setView) { e.preventDefault(); setView('service-detail', 'SEO Mastery'); } }}>SEO Mastery</a></li>
            <li><a href="#services" onClick={(e) => { if (setView) { e.preventDefault(); setView('service-detail', 'Brand Marketing'); } }}>Brand Marketing</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-column footer-contact">
          <h4>Contact</h4>
          <div className="contact-item">
            <span className="contact-icon">✉</span>
            <span>vinushna.lakkakula@cabptoidsolutions.com</span>
          </div>
          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <span>+91 63047 65654</span>
          </div>
          <div className="contact-item" style={{ marginTop: '5px' }}>
            <span className="contact-icon"><FontAwesomeIcon icon={faLinkedin} style={{ color: '#0077b5' }} /></span>
            <span>
              <a href="https://www.linkedin.com/in/vinushnalakkakula" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.3s ease' }} onMouseOver={(e) => e.target.style.color = '#4db8ff'} onMouseOut={(e) => e.target.style.color = 'inherit'}>
                Vinushna Lakkakula
              </a>
            </span>
          </div>
          <div className="contact-item">
            <span className="contact-icon">📍</span>
            <span>
              2nd floor, Aikya Vihar, Kavuri Hills,<br />
              Hyderabad, Telangana - 500033
            </span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">© 2017 Cabptoid Solutions. All rights reserved.</p>
        <a href="#home" className="back-to-top" title="Back to Top">
          <span className="arrow">↑</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;

